export const GET_LIFE_EVENT_KEY = 'life_event';

export const REMOVE_LIFE_EVENT_QUERY_KEY = ['remove', 'life_event'] as const;
